module.exports = __webpack_public_path__ + "static/media/img-tit.df18384e.gif";